/**
 * Flowsheet (texnologik sxema) moduli: sxema → graf → ketma-ket modulli yechim.
 * Sxemalar reyestri pack'lardan to'ldiriladi.
 */
import type { Flowsheet } from './schema';

export * from './schema';
export * from './stream';
export * from './nodes';
export * from './graph';
export * from './solve';
export * from './reactors';

const REGISTRY = new Map<string, Flowsheet>();

export function registerFlowsheets(list: readonly Flowsheet[]): void {
  for (const f of list) REGISTRY.set(f.id, f);
}

export function clearFlowsheets(): void {
  REGISTRY.clear();
}

export function allFlowsheets(): Flowsheet[] {
  return [...REGISTRY.values()];
}

export function getFlowsheet(id: string): Flowsheet {
  const f = REGISTRY.get(id);
  if (!f) throw new Error(`Unknown flowsheet: ${id} (pack yuklanganmi?)`);
  return f;
}
